import styled from 'styled-components';
import { variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ComponentVariants } from './type';

export const CreditCardNumberWrapper = styled.div<{
  variant?: ComponentVariants;
}>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'CreditCardNumber', 'variant')
    )};
`;

CreditCardNumberWrapper.defaultProps = {
  variant: 'regular',
};
